import RichText from "@/components/RichText";

const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { day: "Lundi — vendredi", hours: "9h — 18h" } },
  { id: "fallback-2", props: { day: "Samedi", hours: "Sur rendez-vous" } },
];

const DEFAULTS = { heading: "Horaires et accès", subheading: "", address_line: "", note: "", anchor_id: "" };

export default function OpeningHoursSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const rows = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false && b.props?.day);
  // Sans aucune ligne d'horaire, il reste l'adresse et la note : la section
  // garde du sens, on ne la fait disparaître que si TOUT est vide.
  if (!rows.length && !t.address_line && !t.note) return null;

  return (
    <section id={t.anchor_id || undefined} className="max-w-[900px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <div className="border-control border-stone rounded-xl bg-white p-6 md:p-8">
        <RichText
          as="h2"
          className="font-display font-semibold text-[24px] md:text-[28px] leading-tight tracking-[-0.02em] text-ink"
          html={t.heading}
        />
        {t.subheading && <RichText as="p" preserveParagraphs className="text-[15px] text-graphite mt-2" html={t.subheading} />}

        {!!rows.length && (
          <dl className="mt-6 divide-y divide-stone">
            {rows.map((block) => (
              <div key={block.id} data-block-key={block.id} className="flex items-baseline justify-between gap-4 py-2.5">
                <dt className="text-[14px] text-graphite">{block.props.day}</dt>
                <dd className="text-[14px] font-semibold text-ink text-right">{block.props.hours}</dd>
              </div>
            ))}
          </dl>
        )}

        {t.address_line && <p className="mt-5 text-[14px] text-ink">{t.address_line}</p>}
        {t.note && <p className="mt-1.5 text-[13px] text-ash">{t.note}</p>}
      </div>
    </section>
  );
}
